import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap'
import Logo from '../resources/images/icon-red.png';
import ImageFileUpload from '../resources/images/icon_file_image.png';
import ImageFile from '../resources/images/icon_file.png';
import IconText from '../resources/images/icon-text.png';
import { Link, useParams } from 'react-router-dom';
import { getParametersConfig } from '../services/parametersService';
import { properties } from '../utils/Properties_es';


export default function AffiliationInitial() {
    const [show, setShow] = useState(false);
    const handleOpen = () => setShow(true);
    const handleClose = () => setShow(false);
    const { id } = useParams();
    const [costConfig, setCostConfig] = useState(null);
    const [loadingCosts, setLoadingCosts] = useState(true);
    useEffect(() => {
        async function loadCostConfig() {
            try {
                const response = await getParametersConfig();
                const data = response;

                if (Array.isArray(data) && data.length > 0) {
                    setCostConfig(data[0]);
                }
            } catch (error) {
                console.error('Error cargando configuración de costos', error);
            } finally {
                setLoadingCosts(false);
            }
        }

        loadCostConfig();
    }, []);
    return (
        <Container className='text-center my-5'>
            <Row className='pb-5 mb-5 mt-5'>
                <Col >
                    <img src={Logo} alt="icon" />
                </Col>
            </Row>
            <Row className='pb-4 mb-4'>
                <Col>
                    <h2>{properties.affiliation_welcome}</h2>
                    <h1 className='fw-bold text-danger'>{properties.affiliation_title}</h1>
                </Col>
            </Row>
            <Row className='g-3 align-items-stretch justify-content-center'>
                <Col xs={12} md={8}>
                    <Card className='h-100 p-3 shadow-lg text-start rounded-5'>
                        <Card.Body>
                            <Card.Title>{properties.affiliation_requirements_title}</Card.Title>
                            <div className='d-flex align-items-start gap-2 mb-2'>
                                <i className='bi bi-camera-fill text-primary icon-circle'></i>
                                <span>
                                    <strong>{properties.affiliation_photos_count}</strong> (del <strong>{properties.affiliation_photos_interior}</strong>, <strong>{properties.affiliation_photos_front}</strong> y del <strong>{properties.affiliation_photos_inventory}</strong>)
                                </span>
                            </div>
                            <div className='d-flex align-items-start gap-2 mb-2'>
                                <i className='bi bi-file-earmark-text-fill text-primary icon-circle'></i>
                                <span>
                                    <strong>{properties.affiliation_document_label}</strong> {properties.affiliation_document_detail}
                                </span>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Row className='mt-3 justify-content-center'>
                    <Col xs={12} md={8} style={{ cursor: 'pointer' }} onClick={handleOpen}>
                        <div
                            className="text-end text-primary mt-1 small"
                            style={{ fontWeight: 700, fontSize: 18 }}
                        >
                            <span>{properties.affiliation_costs_link}</span>
                        </div>
                    </Col>
                </Row>
            </Row>
            <Row className='mx-auto mt-5'>
                <div >
                    <Button variant='primary' size='lg' className='px-5 py-4 shadow rounded-0'
                        as={Link}
                        to={`/forms/${id}/personal`}>
                        {properties.btn_start}
                    </Button>
                </div>
            </Row>

            <Modal show={show} onHide={handleClose} centered size='lg'>
                <Modal.Header closeButton className='border-bottom-0 px-5 pt-5'>
                    <Modal.Title className='text-center w-100'>
                        <strong>{properties.costs_title}</strong>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className='px-2 pt-5 pb-5 mx-5 mb-5 fs-6'>

                    <div className='d-flex justify-content-between w-100 border-bottom pb-3'>
                        <span>{properties.costs_annual_membership}</span>
                        <span className='fw-bold'>
                            ${costConfig?.annualMembership ?? '-'}
                        </span>
                    </div>

                    <div className='d-flex flex-column py-3 gap-2 border-bottom'>
                        <span>{properties.costs_central_bank_commission}</span>

                        <div className='d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-sm-between gap-1 gap-sm-3'>
                            <span>&bull; {properties.costs_local}</span>
                            <strong className='text-start d-block'>
                                {costConfig?.localCommissionCR ?? '-'}{properties.costs_per_transaction}
                            </strong>
                        </div>

                        <div className='d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-sm-between gap-1 gap-sm-3'>
                            <span>&bull; {properties.costs_international}</span>
                            <strong className='text-start d-block'>
                                {costConfig?.internationalCommissionCr ?? '-'}{properties.costs_per_transaction}
                            </strong>
                        </div>
                    </div>

                    <div className='d-flex justify-content-between w-100 border-bottom pb-2 py-3'>
                        <span>{properties.costs_dataphone_rental}</span>
                        <div className='d-flex gap-1 flex-column'>
                            <strong>
                                ₡{costConfig?.dataphoneRental?.toLocaleString() ?? '-'}
                            </strong>
                            <span>{properties.costs_dollar_equivalent}</span>
                        </div>
                    </div>

                    <div className='d-flex justify-content-between w-100 border-bottom pb-2 py-3'>
                        <span>{properties.costs_maintenance}</span>
                        <strong>
                            ${costConfig?.maintenance ?? '-'}
                        </strong>
                    </div>

                </Modal.Body>
            </Modal>
        </Container>
    )
}